import { TfiAgenda } from "react-icons/tfi";
import { FaTicketAlt } from "react-icons/fa";
import { FaBullhorn } from "react-icons/fa6";
import { FaMapMarked } from "react-icons/fa";
import { FaMicrophone } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa";
import { FaChartBar } from "react-icons/fa";
import { FaShieldAlt } from "react-icons/fa";
import { FaTools } from "react-icons/fa";
import placeImage from "../../assest/event-5.jpg";

const data = [
  {
    icon: <FaCalendarAlt color="#3a6ee8" size={40} />,
    title: "Event Management",
    content:
      " Effortlessly handle event creation, scheduling, and updates. Offer recurring events, social media integration, and personal meeting booking systems, delivering a comprehensive and customizable experience for attendees and exhibitors.",
  },
  {
    icon: <FaTicketAlt color="#3a6ee8" size={40} />,
    title: "Customizable Event Registration and Ticketing",
    content:
      " Offer a tailored registration and ticketing experience. Customize forms, ticket tiers, and pricing, ensuring that attendees enjoy a smooth registration process, complete with real-time updates and confirmations.",
  },
  {
    icon: <FaBullhorn color="#3a6ee8" size={40} />,
    title: "Attendee Communication and Engagement",
    content:
      " Engage attendees through personalized notifications and updates. Utilize features like in-app messaging, email reminders, and live polls to foster communication and enhance the event experience.",
  },
  {
    icon: <FaMapMarked color="#3a6ee8" size={40} />,
    title: "Venue layout and Configuration",
    content:
      " Optimize your venue layout with tools to configure ticketing, seating, and floor plans. Ensure a smooth, organized flow and clear navigation for attendees and participants.",
  },
  {
    icon: <TfiAgenda color="#3a6ee8" size={40} />,
    title: "MultiDay Agenda",
    content:
      "Organize and manage multi-day events with ease. Create a detailed agenda spanning several days, allowing attendees to navigate seamlessly across sessions and activities without missing any key moments.",
  },
  {
    icon: <FaMicrophone color="#3a6ee8" size={40} />,
    title: "Stall, Sponsor, and Conference Room Management",
    content:
      " Manage stall assignments, sponsor booths, and conference rooms efficiently. Provide sponsors and exhibitors with designated spaces and resources for a professional setup that maximizes exposure.",
  },
  {
    icon: <FaClipboardList color="#3a6ee8" size={40} />,
    title: "Registration Management",
    content:
      " Simplify the registration process for various participant categories including employees, sponsors, speakers, and job seekers. Automate confirmations and provide a seamless onboarding experience for all attendees.",
  },
  {
    icon: <FaChartBar color="#3a6ee8" size={40} />,
    title: "Data Analytics",
    content:
      " Gain valuable insights through real-time attendee tracking, surveys, and feedback collection. Use data analytics to measure engagement, refine event strategies, and enhance future events.",
  },
  {
    icon: <FaShieldAlt color="#3a6ee8" size={40} />,
    title: "Security and Privacy",
    content:
      "Ensure data privacy and secure transactions with advanced access control and secure payment options. Prioritize the safety and confidentiality of attendee and organizer information at all stages.",
  },
  {
    icon: <FaTools color="#3a6ee8" size={40} />,
    title: "Administrative Tools",
    content:
      "Streamline event management with user roles, permissions, and content management. Upload, edit, and organize photos, videos, and documents effortlessly with dedicated technical support for uninterrupted operation.",
  },
];

const Features = () => {
  return (
    <div className="feature-section">
      {data.map((feature, index) => (
        <div className="feature-box" key={index}>
          <div className="feature-head">
            {feature.icon}
            <h3>{feature.title}</h3>
          </div>
          <div className="feature-content">
            <div className="feature-content-img">
              <img src={placeImage} alt="Event Placeholder" />
            </div>
            <div className="feature-content-text">
              <p>{feature.content}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Features;
